import styled from 'styled-components';

export const ContainerFilterMovement = styled.div`
  display: flex;
  align-items: center;
`;
